/* MONTAGNE 消磁套組加購 — 全站載入。下拉式選單版（原生 select 無須 JS 即可選） */
(function () {
  if (window.customElements.get('cleansing-addon')) return;

  class CleansingAddon extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.subtitle = this.querySelector('[data-ca-subtitle]');
      this.select = this.querySelector('[data-ca-select]');
      this.thumb = this.querySelector('[data-ca-thumb]');
      this.thumbX = this.querySelector('[data-ca-thumb-x]');
      var self = this;

      if (this.select) {
        this.select.addEventListener('change', function () { self.updateSubtitle(); self.updateThumb(); });
        this.updateThumb();
      }

      if (this.form && !this.form.__cleansingBound) {
        this.form.__cleansingBound = true;
        this.form.addEventListener('submit', this.onSubmit.bind(this), true);
      }
    }

    updateSubtitle() {
      if (!this.subtitle || !this.select) return;
      var opt = this.select.options[this.select.selectedIndex];
      var name = opt ? (opt.getAttribute('data-name') || '') : '';
      this.subtitle.textContent = (this.select.value && name) ? ('已加購：' + name) : '選填 · 現折 $100';
    }

    updateThumb() {
      if (!this.thumb || !this.select) return;
      var opt = this.select.options[this.select.selectedIndex];
      var img = opt ? (opt.getAttribute('data-image') || '') : '';
      if (img) {
        this.thumb.src = img; this.thumb.hidden = false;
        if (this.thumbX) this.thumbX.hidden = true;
      } else {
        this.thumb.removeAttribute('src'); this.thumb.hidden = true;
        if (this.thumbX) this.thumbX.hidden = false;
      }
    }

    async onSubmit(e) {
      var form = this.form;
      if (form.__cleansingPassthrough) { form.__cleansingPassthrough = false; return; }
      var id = this.select ? this.select.value : '';
      var hidden = form.querySelector('input[name="properties[_addon_group]"]');
      if (!id) { if (hidden) hidden.remove(); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      // 盒子數量 = 手鍊數量（買幾條手鍊就配幾個盒子）
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var groupId = 'mg' + Date.now() + Math.floor(Math.random() * 1000);
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[_addon_group]';
        form.appendChild(hidden);
      }
      hidden.value = groupId;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty, properties: { _addon_group: groupId, _addon: '1' } }] })
        });
      } catch (err) { /* 靜默：加購失敗仍加入主商品 */ }
      form.__cleansingPassthrough = true;
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    }
  }

  window.customElements.define('cleansing-addon', CleansingAddon);
})();
